<template>
  <div class="card col-12" v-if="penaltyPaidData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Статистик</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            penaltyPaidData.params.mode = 1;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 1 ? 'active' : ''}`
          "
          role="button"
          >1D</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 2;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 2 ? 'active' : ''}`
          "
          role="button"
          >1W</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 3;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 3 ? 'active' : ''}`
          "
          role="button"
          >1M</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 4;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 4 ? 'active' : ''}`
          "
          role="button"
          >1Y</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 5;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 5 ? 'active' : ''}`
          "
          role="button"
          >ALL</a
        >
      </nav>
    </div>
    <div class="card-body row ">
      <div class="row row-xs">
          <div class="col-sm-6 col-lg-3">
            <div class="card card-body bd-0">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Тэтгэлэг зээлд хамрагдсан тоо</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{{ penaltyPaidData.data.tentsegchCount }}</h3>
                <!-- <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-success">1.2% <i class="icon ion-md-arrow-up"></i></span> than last week</p> -->
              </div>
              <!-- chart-three -->
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
            <div class="card card-body bd-0">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Олгосон санхүүжилтийн дүн</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{{ penaltyPaidData.data.sanhuujilt | formatMoney(2, ",", ".") }}</h3>
                <!-- <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-danger">0.7% <i class="icon ion-md-arrow-down"></i></span> than last week</p> -->
              </div>
              <!-- chart-three -->
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body bd-0">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Төлөдсөн зээлийн дүн</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{{ penaltyPaidData.data.paidLoan | formatMoney(2, ",", ".") }}</h3>
                <!-- <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-danger">0.3% <i class="icon ion-md-arrow-down"></i></span> than last week</p> -->
              </div>
              <!-- chart-three -->
            </div>
          </div><!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body bd-0">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">Төгссөн суралцагчийн тоо</h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{{ penaltyPaidData.data.finishedCount }}</h3>
                <!-- <p class="tx-11 tx-color-03 mg-b-0"><span class="tx-medium tx-success">2.1% <i class="icon ion-md-arrow-up"></i></span> than last week</p> -->
              </div>
              <!-- chart-three -->
            </div>
          </div><!-- col -->
          
          
          
          
          
          
          
        </div>

    </div>
    <div class="card-footer tx-11 tx-color-03">
      <div class="d-flex">
        Хамрах хугацаа:
        {{ penaltyPaidData.data.processed.startDate | moment("YYYY.MM.DD") }}
        -
        {{ penaltyPaidData.data.processed.endDate | moment("YYYY.MM.DD")
        }}
        <div class="mg-l-auto">
          Боловсруулсан:
        {{ penaltyPaidData.data.processed.time.toFixed(2) }}сек
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props:{
    title: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {

      penaltyPaidData: {
        rdy: 0,
        params: {
          mode: 5,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          count: 0,
          budget: 0,
          processed: {
            time: 0,
            startDate: "",
            endDate: "",
          },
        },
      },
    };
  },
  mounted() {
    this.loadPenaltyPaidData();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    // reloadData() {
    //   this.series[0].data = this.penaltyDashboardData.data.list
    //     .filter((x) => x.show == true)
    //     .map((item) => {
    //       return { x: item.pnltTypeTask, y: item.count };
    //     });
    //   this.chartKey++;
    // },
    loadPenaltyPaidData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: this.url },
        params: {
          mode: this.penaltyPaidData.params.mode,
          startDate: this.penaltyPaidData.params.startDate,
          endDate: this.penaltyPaidData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.penaltyPaidData.data = res.data;
          // this.seriesSpark1[0].data = res.data.pnltCounts.map(x=>x.count);
          // this.chartOptionsSpark1.xaxis.categories = res.data.pnltCounts.map(x=>x.date);
          // this.seriesSpark2[0].data = res.data.pnltBudgets.map(x=>x.count);
          // this.chartOptionsSpark2.xaxis.categories = res.data.pnltBudgets.map(x=>x.date);
          this.penaltyPaidData.rdy = true;
          
          //this.vehicleCountData.processed = res.data.processed
        }
      });
    },
  },
};
</script>
